import { Backdrop, Button, Paper, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideAuthModal, showAuthModal } from "store/application/application-action";
import { authModalTabs } from "store/application/application-state";
import colors from "../../../../theme/themeConstants";
import cross from "components/icons/cross-black.svg";
import TopMenu from "../../TopMenu";
import AuthSignUp, { PopupSubheader } from "./AuthSignUp";
import AuthLogin from "./AuthLogin";
import { IAppState } from "../../../../store/app-state";

import "./AuthPopup.scss";

type ITabs = {
  [name in authModalTabs]: string;
};

const TABS: ITabs = {
  login: "Log In",
  signup: "Sign Up",
};

const AuthPopup = () => {
  const { tab } = useSelector((state: IAppState) => state.application.authModal);

  const [isStartedTab, setIsStartedTab] = useState(true);

  const [currentStep, setCurrentStep] = useState(0);

  const dispatch = useDispatch();

  const togglePopup = () => {
    dispatch(hideAuthModal());
  };

  const handleCurrentTab = (tabValue: string) => {
    const tabIndex = Object.values(TABS).findIndex((value) => {
      return value === tabValue;
    });

    const tab = Object.keys(TABS)[tabIndex] as keyof ITabs;

    dispatch(showAuthModal({ tab }));
  };

  const next = (increment: number = 1) => {
    setCurrentStep(currentStep + increment);
  };

  const prev = (decrement: number = 1) => {
    if (currentStep - decrement >= 0) {
      setCurrentStep(currentStep - decrement);
    }
  };

  useEffect(() => {
    setIsStartedTab(currentStep === 0);
  }, [currentStep]);

  return (
    <Backdrop
      open={true}
      sx={{
        zIndex: "var(--authZ)",
      }}
    >
      <Paper
        className="authPopup"
        sx={{
          "@media screen and (max-width: 767px)": {
            maxHeight: "95vh",
            maxWidth: "90%",
            padding: "1rem"
          },
        }}
      >
        <PopupSubheader>
          {isStartedTab && (
            <TopMenu
              topicValues={Object.values(TABS)}
              currentTopic={TABS[tab]}
              setCurrentTopic={handleCurrentTab}
              color="black"
            />
          )}
          {(!isStartedTab) && (
            <Title>{TABS[tab]}</Title>
          )}
          <Button onClick={togglePopup}><img src={cross} alt="close popup" /></Button>
        </PopupSubheader>

        {tab === "signup" && (
          <AuthSignUp
            currentStep={currentStep}
            next={next}
            prev={prev}
          />
        )}

        {tab === "login" && (
          <AuthLogin
            currentStep={currentStep}
            next={next}
            prev={prev}
            onClose={togglePopup}
          />
        )}
      </Paper>
    </Backdrop>
  );
};

export default AuthPopup;

const Title = styled("p")({
  fontSize: "20px",
  color: colors.textDark
});
